import React from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { withLocalize } from 'react-localize-redux'
import { trainingPackages } from 'redux/modules'
import PropTypes from 'prop-types'
import Loader from './Loader'

const TrainingPackageLoader = props => {
  const {
    children,
    trainingPackageUuid,
    fetchTrainingPackage,
    activeLanguage: { code: locale },
    ...restProps
  } = props

  return (
    <Loader
      fetchMethod={params =>
        fetchTrainingPackage(trainingPackageUuid, { ...params, locale })
      }
      triggers={[locale]}
      {...restProps}
    >
      {children}
    </Loader>
  )
}

TrainingPackageLoader.propTypes = {
  children: PropTypes.node.isRequired,
  trainingPackageUuid: PropTypes.string.isRequired,
  fetchTrainingPackage: PropTypes.func.isRequired,
  activeLanguage: PropTypes.shape().isRequired,
}

export default compose(
  connect(
    null,
    { fetchTrainingPackage: trainingPackages.fetchTrainingPackage }
  ),
  withLocalize
)(TrainingPackageLoader)
